import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
} from 'chart.js';
import Title from '../Text/Title/Title';
import { SubTitle } from '../Text/Subtitle/SubTitle';

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
);


export const LineChart = ({ member, inputData }) => {
    const data = {
        labels: inputData.map(item => item.mesAno),
        datasets: [{
            labels: 'Sales',
            data: inputData.map(item => item.numeroDeItens),
            backgroundColor: 'rgb(75, 192, 192)',
            pointBorderColor: 'rgb(75, 192, 192)',
            fill: true,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        }]
    }

    const options = {
        plugins: {
            legend: false,
        },
        scales: {
            y: {
                beginAtZero: true,
            }
        }
    }

    return (
        <div id="chartCanvas" >
            <Title>Relatório Métricas - {member.fullName}</Title>
            <SubTitle>Todo o Tempo</SubTitle>
            <hr className='hr mb-5' />
            <Line data={data} options={options} />
        </div >
    )
}
